module.exports = __webpack_public_path__ + "assets/img/组 540@2x.e294a1f2.png";